"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const apiOrderToAppOrder_1 = __importDefault(require("../../libs/apiOrderToAppOrder"));
const appBatchToApiBatch_1 = __importDefault(require("../../libs/appBatchToApiBatch"));
const appPaymentToApiPayment_1 = __importDefault(require("../../libs/appPaymentToApiPayment"));
const appPaymentsToApiPayments_1 = __importDefault(require("../../libs/appPaymentsToApiPayments"));
class OrderApi {
    constructor(api) {
        this.api = api;
    }
    /* -------------------------------------------------------------------------- */
    /*                                 Order Level                                */
    /* -------------------------------------------------------------------------- */
    /**
     * 取得訂單資料
     * 根據 orderId
     */
    getOrder(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order?id=${orderId}`;
            const response = yield this.api.axiosGo.get(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data.data[0]);
        });
    }
    /**
     * 取得訂單資料
     * 根據 serial 或 code
     * ? 看起來跟 getOrders 很像，可以整合成一個嗎？
     * ? 用在 OrderList 裡面的 filtered，看起來只有對 serial 有用，code 好像沒在用
     * ? const format = /^[0-9]{3}-[0-9]{5}|[0-9]{3}-[0-9]{4}$/
     */
    getOrderByInfo(info) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/info';
            const response = yield this.api.axiosGo.get(endpoint, { params: info });
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 取得訂單資料
     */
    getOrders(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order';
            const response = yield this.api.axiosGo.get(endpoint, { params: query });
            return response.data.data.map(apiOrderToAppOrder_1.default);
        });
    }
    /**
     * 新增訂單
     * ! 還有在使用，checkoutSubOrder 但是為什麼？
     */
    createOrder(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order';
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 修改訂單
     * ! 還有在使用但應該要被棄用，應改用 orderimport
     */
    updateOrder(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    surchargeOrder(orderId, surcharge) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/surcharge`;
            const data = surcharge;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 覆蓋掉 order.modifiers
     * @deprecated 改用 orderimport
     */
    updateModifiers(orderId, modifiers) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/modifier`;
            const data = { modifiers };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 修改人數
     * @deprecated 改用 orderimport
     */
    updateCustomerCount(orderId, adults, children) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/customercount`;
            const data = {
                count: adults + children,
                adults,
                children,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 移桌，給 from, to 桌號
     * @deprecated 目前沒有專案使用
     */
    updateTable(orderId, from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/table`;
            const data = { from, to };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 修改 tags
     * ! 還有在使用但應該要被棄用，應改用 orderimport
     */
    updateTags(orderId, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/tag`;
            const data = { tags };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 併單，從 fromOrderId 併到 orderId
     * @deprecated 目前沒有專案使用
     */
    mergeOrder(orderId, fromOrderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/merge`;
            const data = { orderId: fromOrderId };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 訂單付款
     * @deprecated 目前沒有專案使用
     */
    payOrder(orderId, payment) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/pay`;
            const data = (0, appPaymentToApiPayment_1.default)(payment);
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    multipayOrder(order, payments) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${order.id}/multipay`;
            const data = (0, appPaymentsToApiPayments_1.default)(payments);
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 修改第三方付款的 payment 時還是要使用
     * 其他情況改用 orderimport
     */
    updateOrderPayment(orderId, paymentId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/payment/${paymentId}`;
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 刪除訂單 payment
     * @deprecated 改用 orderimport
     */
    deleteOrderPayment(orderId, paymentId, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/payment/${paymentId}`;
            const data = { params: { reason } };
            const response = yield this.api.axiosGo.delete(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 修改訂單備註
     * @deprecated 改用 orderimport
     */
    updateOrderRemark(orderId, remark) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/remark`;
            const data = { remark };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 外帶單、外送單接單
     * 或是 confirm 指定長度的 batches (沒有使用)
     */
    confirmOrder(id, deviceId, reconfirm = false, batchLength = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/confirm`;
            const data = {
                deviceId,
                batchIndices: [...Array(batchLength).keys()],
                reconfirm,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 取消、退桌、作廢、外送拒接單
     */
    cancelOrder(id, reason, identifier, approver) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/cancel`;
            const data = {
                reason,
                identifier,
                approver,
            };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 確認堂食 batch
     * @deprecated 改用 orderimport
     */
    confirmBatch(id, deviceId, reconfirm = false, index = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/confirm`;
            const data = {
                deviceId,
                batchIndices: [index],
                reconfirm,
            };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 取消堂食 batch
     * ! 還有在使用但應該要被棄用，應改用 orderimport
     */
    cancelBatch(id, deviceId, index) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/cancelbatch`;
            const data = { deviceId, batchIndices: [index] };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 出餐
     */
    readyOrder(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/ready`;
            const response = yield this.api.axiosGo.put(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 取餐
     */
    completeOrder(id, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/complete`;
            const data = { code };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 手動送達 (店家自己送才要)
     */
    deliverOrder(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/deliver`;
            const response = yield this.api.axiosGo.put(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 紀錄訂單是否已印結帳單
     * 需開啟 merchant.setting.enableCheckoutReceipt
     * order.printedCheckoutReceipt: ture 代表已印過結帳單
     * ! 還有在使用但應該要被棄用，應改用 orderimport
     */
    printedCheckoutReceipt(orderId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/printedcheckoutreceipt`;
            const data = { value: true };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return response.data;
        });
    }
    /**
     * 通知客人可以取餐
     */
    sendPickupNotify(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/pickupnotify`;
            const response = yield this.api.axiosGo.post(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 叫侍應
     * @deprecated 改用 orderimport
     */
    serveTable(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/service`;
            const response = yield this.api.axiosGo.put(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    multiItemTag(id, items) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${id}/multiitemtag`;
            const data = { items };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /* -------------------------------------------------------------------------- */
    /*                                 Batch Level                                */
    /* -------------------------------------------------------------------------- */
    /**
     * 提交 batch
     */
    submitBatch(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = (0, appBatchToApiBatch_1.default)(params);
            const endpoint = `/m/order/${params.orderId}/submit`;
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /* -------------------------------------------------------------------------- */
    /*                                 Item Level                                 */
    /* -------------------------------------------------------------------------- */
    /**
     * 修改餐點價格
     */
    updateItemPrice(orderId, itemId, price) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/price`;
            const data = { price };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 修改餐點折扣
     */
    updateItemModifiers(orderId, itemId, modifiers) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/modifier`;
            const data = { modifiers };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 修改餐點標籤
     * @deprecated 目前沒有專案使用
     */
    updateItemTags(orderId, itemId, tags) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/tag`;
            const data = { tags };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 取消餐點
     * @deprecated 目前沒有專案使用
     */
    cancelOrderItem(orderId, itemId, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/cancel`;
            const data = { reason };
            const response = yield this.api.axiosGo.put(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 還原已取消的餐點
     * @depreacted 目前沒有專案使用
     */
    revealOrderItem(orderId, itemId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/reveal`;
            const response = yield this.api.axiosGo.put(endpoint);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * @deprecated 目前沒有專案使用
     */
    surchargeOrderItems(uid, itemIDs, value) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${uid}/surchargemenu`;
            const data = { itemIDs, value };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /**
     * 項目轉枱
     * @deprecated 目前沒有專案使用
     */
    transferItem(orderId, itemId, newOrderId, submittedAt, batchID) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/item/${itemId}/transfer`;
            const data = { newOrderId, submittedAt, batchID };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return (0, apiOrderToAppOrder_1.default)(response.data);
        });
    }
    /* -------------------------------------------------------------------------- */
    /*                             Statistic & Report                             */
    /* -------------------------------------------------------------------------- */
    /**
     * cancelled: true  => 分類取消報表
     * cancelled: false => 分類銷售報表 (目前沒在使用)
     */
    getOrderStatCategory(from, to, cancelled = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const api = cancelled ? this.api.axiosGo : this.api.axiosNode;
            const endpoint = '/m/order/stat/category';
            const params = { from, to, cancelled };
            const response = yield api.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 總計報表 v2
     * > 結構非常複雜就先不寫型別了...
     */
    getOrderStatV2(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/v2/summary';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 枱號群銷售報表
     */
    getTableStatistic(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/table';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 選項銷售報表
     */
    getOptionStatistic(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/option';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 取消訂單報表
     * ? 跟 /m/merchantportal/cancelledorders 功能類似
     */
    getOrderStatCancel(from, to, takeaway) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/cancel';
            const params = { from, to };
            if (takeaway != null) {
                params.takeaway = takeaway;
            }
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 取得訂單分類標籤更改記錄報表
     *
     * @param {string} from
     * @param {string} to
     * @return {*}  {Promise<IOrderCategoryTagUpdateData[]>}
     * @memberof OrderApi
     */
    getOrderStatCategoryTagUpdate(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/categorytagupdate';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 寫入更新訂單分類標籤記錄
     *
     * @param {string} orderId
     * @param {IOrderCategoryTagUpdateRequestData} data
     * @return {*}  {Promise<boolean>}
     * @memberof OrderApi
     */
    updateOrderStatCategoryTagUpdate(orderId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/m/order/${orderId}/categorytagupdate`;
            yield this.api.axiosGo.post(endpoint, data);
            return true;
        });
    }
    /**
     * 取消訂單報表
     * ? 跟 /m/order/stat/cancel 功能類似，但是資料比較多
     * MERCHANT_APP 也有在用
     */
    getCancelledOrders(from, to, type) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchantportal/cancelledorders';
            const params = { date_start: from, date_end: to, type };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 分類銷售報表
     * MERCHANT_APP 也有在用
     */
    getSalesReportCategory(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/merchantportal/salesreportbycategory';
            const params = { date_start: from, date_end: to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 這個 API 當初做完後沒有使用，而且似乎有問題
     * 新的 API 是 /m/order/stat/table
     * @deprecated
     */
    getTableGroupSummary(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/tablegroupsummary';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 廚房部門報表
     * @deprecated 目前沒有專案使用
     */
    getOrderStatKitchenDepartment(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/kitchendepartmentsummary';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /**
     * 尚未付款訂單報表
     * @deprecated 目前沒有專案使用
     */
    getOrderStatUnpaid(from, to) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/order/stat/unpaid';
            const params = { from, to };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
    /* -------------------------------------------------------------------------- */
    /*                                 Orderimport                                */
    /* -------------------------------------------------------------------------- */
    /**
     * 原本是設計可以一次上傳多張訂單
     * 但是現在實做上是一次僅上傳一張訂單
     */
    syncOrder(apiOrders) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/m/orderimport';
            const data = { orders: apiOrders };
            const response = yield this.api.axiosGo.post(endpoint, data);
            return response.data;
        });
    }
}
exports.default = OrderApi;
//# sourceMappingURL=Order.js.map